<template>
  <div class="min-h-screen py-16 px-4 sm:px-6 lg:px-8">
    <div class="max-w-2xl mx-auto text-center mb-12">
      <h1 class="text-3xl sm:text-4xl font-bold text-white mb-3">Featured Products</h1>
      <p class="text-gray-400">
        Products I've built and shipped — from idea to production. Each one is live and visitable.
      </p>
    </div>

    <ProjectsGrid />
  </div>
</template>

<script setup>
import ProjectsGrid from '../components/ProjectsGrid.vue';
</script>
